module.exports = __webpack_public_path__ + "img/everTrust.7415c044.png";